(() => {
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => [...c.querySelectorAll(s)];
  const body = document.body;
  const globalScrim = $('#GlobalScrim');
  const mobileMenu = $('#MobileMenu');
  const searchDrawer = $('#SearchDrawer');

  function formatMoney(cents){
    try { return new Intl.NumberFormat(window.themeLocale || 'en', {style:'currency', currency:window.themeCurrency || 'EGP', maximumFractionDigits:2}).format((Number(cents)||0)/100); }
    catch(e){ return `${((Number(cents)||0)/100).toFixed(2)} ${window.themeCurrency || 'EGP'}`; }
  }
  function setScrim(open){ if(!globalScrim) return; globalScrim.classList.toggle('is-open',open); body.classList.toggle('drawer-open',open); }
  function closeAll(){ mobileMenu?.classList.remove('is-open'); searchDrawer?.classList.remove('is-open'); $('#CartDrawer')?.classList.remove('is-open'); globalScrim?.classList.remove('is-open'); body.classList.remove('drawer-open'); }
  function openMobile(){ closeAll(); mobileMenu?.classList.add('is-open'); setScrim(true); }
  function openSearch(){ closeAll(); searchDrawer?.classList.add('is-open'); setScrim(true); setTimeout(()=>searchDrawer?.querySelector('input[type=search]')?.focus(),180); }
  function openCart(){ closeAll(); $('#CartDrawer')?.classList.add('is-open'); setScrim(true); }

  document.addEventListener('click', async (e) => {
    if(e.target.closest('[data-mobile-menu-open]')) openMobile();
    if(e.target.closest('[data-mobile-menu-close]') || e.target.closest('[data-global-scrim]')) closeAll();
    if(e.target.closest('[data-search-open]')) openSearch();
    if(e.target.closest('[data-search-close]')) closeAll();
    if(e.target.closest('[data-cart-open]')) openCart();
    if(e.target.closest('[data-cart-close]')) closeAll();
    const change = e.target.closest('[data-cart-change]');
    if(change){ e.preventDefault(); change.disabled=true; await changeCart(Number(change.dataset.line), Number(change.dataset.quantity)); }
    const quick = e.target.closest('[data-quick-add]');
    if(quick){ e.preventDefault(); await openQuickAdd(quick.dataset.handle); }
    if(e.target.closest('[data-modal-close]')) closeQuickAdd();
  });
  document.addEventListener('keydown', e => { if(e.key === 'Escape'){ closeAll(); closeQuickAdd(); }});


  // Product-card color swatches: preview a selected color without leaving the listing.
  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('[data-product-card-swatch]');
    if(!swatch) return;
    e.preventDefault();
    e.stopPropagation();
    const card = swatch.closest('[data-product-card]');
    if(!card) return;

    $$('[data-product-card-swatch]', card).forEach(btn => btn.classList.toggle('is-selected', btn === swatch));
    const selectedColor = $('[data-selected-color]', card);
    if(selectedColor) selectedColor.textContent = swatch.dataset.colorName || '';

    const variantId = swatch.dataset.variantId;
    const links = $$('[data-product-card-link], [data-product-card-title-link]', card);
    links.forEach(link => {
      if(!variantId) return;
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantId);
      link.href = url.toString();
    });

    const img = $('[data-product-card-image]', card);
    const imageUrl = swatch.dataset.imageUrl;
    if(img && imageUrl){
      img.src = imageUrl;
      img.removeAttribute('srcset');
      card.setAttribute('data-swatch-active','true');
    }

    const priceWrap = $('[data-product-card-price]', card);
    if(priceWrap && swatch.dataset.variantPrice){
      const price = Number(swatch.dataset.variantPrice || 0);
      const compare = Number(swatch.dataset.variantCompare || 0);
      priceWrap.innerHTML = compare > price
        ? `<span class="price__current">${formatMoney(price)}</span><span class="price__compare">${formatMoney(compare)}</span>`
        : `<span class="price__current">${formatMoney(price)}</span>`;
    }
  });

  async function refreshCart(){
    const res = await fetch(`${window.themeRoutes.cartUrl}?section_id=cart-drawer`, {headers:{'X-Requested-With':'XMLHttpRequest'}});
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html,'text/html');
    const fresh = doc.querySelector('#CartDrawerSection');
    const current = document.querySelector('#CartDrawerSection');
    if(fresh && current) current.replaceWith(fresh);
    const cart = await fetch(window.themeRoutes.cartJsonUrl).then(r=>r.json());
    $$('[data-cart-count]').forEach(el=>{ el.textContent=cart.item_count; el.hidden=cart.item_count===0; });
  }
  async function changeCart(line, quantity){
    await fetch(window.themeRoutes.cartChangeUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line,quantity})});
    await refreshCart(); openCart();
  }

  const quickModal = $('#QuickAddModal');
  const quickContent = $('#QuickAddContent');
  let quickProduct = null;
  function closeQuickAdd(){ quickModal?.classList.remove('is-open'); quickModal?.setAttribute('aria-hidden','true'); body.classList.remove('drawer-open'); }
  async function openQuickAdd(handle){
    if(!quickModal || !quickContent) return;
    quickModal.classList.add('is-open'); quickModal.setAttribute('aria-hidden','false'); body.classList.add('drawer-open');
    quickContent.innerHTML='<div class="quick-add__content">Loading…</div>';
    try{
      const root=(window.themeRoutes.root || '/').replace(/\/?$/,'/');
      quickProduct=await fetch(`${root}products/${handle}.js`).then(r=>{if(!r.ok)throw new Error('Product load failed');return r.json()});
      renderQuickAdd(quickProduct);
    }catch(err){ quickContent.innerHTML='<div class="quick-add__content"><p>Could not load this product.</p></div>'; }
  }
  function renderQuickAdd(p){
    const first=p.variants.find(v=>v.available) || p.variants[0];
    const image=(first && first.featured_image && (first.featured_image.src || first.featured_image)) || p.featured_image || (p.images && p.images[0]) || '';
    const optionObjects=(p.options||[]).map((o,i)=> typeof o==='string' ? {name:o,position:i+1,values:[...new Set(p.variants.map(v=>v.options[i]))]} : o);
    quickContent.innerHTML=`<div class="quick-add__image">${image?`<img src="${image}" alt="">`:''}</div><div class="quick-add__content"><p class="eyebrow">QUICK ADD</p><h2>${escapeHtml(p.title)}</h2><div class="quick-add__price" data-qa-price>${formatMoney(first.price)}</div><form data-qa-form>${optionObjects.map((o,i)=>`<label class="field-label">${escapeHtml(o.name)}</label><select class="select" data-qa-option data-index="${i}">${(o.values||[]).map(v=>`<option value="${escapeAttr(v)}" ${first.options[i]===v?'selected':''}>${escapeHtml(v)}</option>`).join('')}</select>`).join('')}<label class="field-label">Quantity</label><input class="input" type="number" min="1" value="1" data-qa-quantity><button class="button button--full" style="margin-top:18px" type="submit" data-qa-submit ${first.available?'':'disabled'}>${first.available?'Add to cart':'Sold out'}</button><a href="${p.url}" style="display:block;text-align:center;margin-top:14px;text-decoration:underline">View full details</a></form></div>`;
    $$('#QuickAddContent [data-qa-option]').forEach(el=>el.addEventListener('change',updateQuickVariant));
    $('#QuickAddContent [data-qa-form]')?.addEventListener('submit',submitQuickAdd);
  }
  function currentQuickVariant(){
    const values=$$('#QuickAddContent [data-qa-option]').map(el=>el.value);
    return quickProduct?.variants.find(v=>v.options.every((x,i)=>x===values[i])) || quickProduct?.variants[0];
  }
  function updateQuickVariant(){
    const v=currentQuickVariant(); if(!v) return;
    const price=$('#QuickAddContent [data-qa-price]'); if(price) price.textContent=formatMoney(v.price);
    const btn=$('#QuickAddContent [data-qa-submit]'); if(btn){btn.disabled=!v.available;btn.textContent=v.available?'Add to cart':'Sold out'}
    const img=$('#QuickAddContent .quick-add__image img'); const src=v.featured_image && (v.featured_image.src||v.featured_image); if(img&&src) img.src=src;
  }
  async function submitQuickAdd(e){
    e.preventDefault(); const v=currentQuickVariant(); if(!v?.available) return;
    const btn=$('#QuickAddContent [data-qa-submit]'); if(btn){btn.disabled=true;btn.textContent='Adding…'}
    const quantity=Math.max(1,Number($('#QuickAddContent [data-qa-quantity]')?.value||1));
    const res=await fetch(window.themeRoutes.cartAddUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity}]})});
    if(res.ok){ closeQuickAdd(); await refreshCart(); openCart(); } else if(btn){btn.disabled=false;btn.textContent='Try again'}
  }
  function escapeHtml(v=''){return String(v).replace(/[&<>'"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]))}
  function escapeAttr(v=''){return escapeHtml(v)}

  // Product page variant logic
  $$('.product-main[data-product-section]').forEach(section=>{
    const json=section.querySelector('[data-product-json]'); if(!json)return;
    let product; try{product=JSON.parse(json.textContent)}catch(e){return}
    const selects=$$('[data-product-option]',section); const idInput=$('[data-variant-id]',section); const price=$('[data-product-price]',section); const compare=$('[data-product-compare]',section); const badge=$('[data-product-badge]',section); const submit=$('[data-product-submit]',section);
    function selectedVariant(){const values=selects.map(s=>s.value);return product.variants.find(v=>v.options.every((o,i)=>o===values[i]))}
    function update(){const v=selectedVariant();if(!v)return;if(idInput)idInput.value=v.id;if(price)price.textContent=formatMoney(v.price);if(compare){compare.textContent=v.compare_at_price?formatMoney(v.compare_at_price):'';compare.hidden=!(v.compare_at_price>v.price)}if(badge){if(v.compare_at_price>v.price){badge.hidden=false;badge.textContent=`Save ${Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)}%`}else badge.hidden=true}if(submit){submit.disabled=!v.available;submit.textContent=v.available?'Add to cart':'Sold out'}if(history.replaceState){const u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u)}}
    selects.forEach(s=>s.addEventListener('change',update));
    section.addEventListener('click',e=>{const b=e.target.closest('[data-product-qty]');if(!b)return;const q=$('[data-product-quantity]',section);if(!q)return;let n=Number(q.value)||1;n=b.dataset.productQty==='plus'?n+1:Math.max(1,n-1);q.value=n});
    const form=$('#MainProductForm',section); form?.addEventListener('submit',async e=>{if(!submit||submit.name==='checkout')return;e.preventDefault();submit.disabled=true;submit.textContent='Adding…';const fd=new FormData(form);const res=await fetch(window.themeRoutes.cartAddUrl,{method:'POST',headers:{'Accept':'application/json'},body:fd});if(res.ok){await refreshCart();openCart()}else{submit.disabled=false;submit.textContent='Try again'} });
  });

  // Two-tab measurements panel, with product-level data and real Shopify variant sync.
  function initMeasurements(root=document){
    $$('[data-measurements-dialog]',root).forEach(dialog=>{
      if(dialog.dataset.measurementsReady==='true')return;
      dialog.dataset.measurementsReady='true';
      const section=dialog.closest('[data-product-section]');
      const opener=section?.querySelector('[data-measurements-open]');
      if(!section||!opener)return;
      const normalize=s=>String(s??'').trim().toLocaleLowerCase();
      const dataRows=$$('[data-measurement-row]',dialog);
      const rows={item:dataRows.filter(r=>r.dataset.measurementRow==='item'),body:dataRows.filter(r=>r.dataset.measurementRow==='body')};
      const buttons=dialog.querySelector('[data-measurements-sizes]');
      const sizebar=dialog.querySelector('[data-measurements-sizebar]');
      const basket=dialog.querySelector('[data-measurements-add]');
      const message=dialog.querySelector('[data-measurements-message]');
      const tabs=$$('[data-measurements-tab]',dialog);
      const panels={item:dialog.querySelector('[data-measurements-panel="item"]'),body:dialog.querySelector('[data-measurements-panel="body"]')};
      const variantSelects=$$('[data-product-option]',section);
      const findSizeOption=()=>variantSelects.find(s=>/\bsize\b|taille|talla|مقاس|المقاس/i.test(s.dataset.optionName||'')) ||
        variantSelects.find(s=>rows.item.some(row=>$$('option',s).some(option=>normalize(option.value)===normalize(row.dataset.size))));
      const sizeOption=findSizeOption();
      const form=section.querySelector('form.product-form');
      const mainSubmit=section.querySelector('[data-product-submit]');
      let product=null;
      try {product=JSON.parse(section.querySelector('[data-product-json]')?.textContent||'null');}catch(e){}
      let activeTab='item';
      let activeSize='';
      const sizeMap=type=>[...new Map(rows[type].map(row=>[normalize(row.dataset.size),row])).values()];
      const formVariant=()=>product?.variants?.find(v=>v.options.every((option,i)=>option===variantSelects[i]?.value));
      const isSizeMatch=row=>Boolean(row&&sizeOption&&$$('option',sizeOption).some(opt=>normalize(opt.value)===normalize(row.dataset.size)));
      const validCm=value=>{
        const txt=String(value??'').trim();
        if(!/^\d+(?:[.,]\d+)?$/.test(txt))return null;
        const n=Number(txt.replace(',','.'));
        return Number.isFinite(n)&&n>=0?n:null;
      };
      const renderCells=(type,row)=>{
        const keys=type==='item'?['chest','length','sleeve']:['chest','waist','hips'];
        keys.forEach(key=>{
          const n=validCm(row?.dataset[key]);
          const cm=dialog.querySelector(`[data-measurement-cm="${type}:${key}"]`);
          const inches=dialog.querySelector(`[data-measurement-in="${type}:${key}"]`);
          const tableRow=dialog.querySelector(`[data-measurement-table-row="${type}:${key}"]`);
          if(tableRow)tableRow.hidden=n===null;
          const helpRow=type==='item'?dialog.querySelector(`[data-measurement-help="${key}"]`):null;
          if(helpRow)helpRow.hidden=n===null;
          if(cm)cm.textContent=n===null?'—':n.toFixed(1);
          if(inches)inches.textContent=n===null?'—':(n/2.54).toFixed(1);
        });
      };
      const activeRow=()=>rows[activeTab].find(row=>normalize(row.dataset.size)===normalize(activeSize));
      const render=()=>{
        const availableSizes=sizeMap(activeTab);
        const found=availableSizes.find(row=>normalize(row.dataset.size)===normalize(activeSize));
        if(!found)activeSize=availableSizes[0]?.dataset.size||'';
        buttons.replaceChildren();
        availableSizes.forEach(row=>{
          const btn=document.createElement('button');
          btn.type='button';
          btn.className='measurements-dialog__size';
          btn.textContent=row.dataset.size;
          btn.dataset.size=row.dataset.size;
          btn.setAttribute('aria-pressed',String(normalize(activeSize)===normalize(row.dataset.size)));
          buttons.append(btn);
        });
        sizebar.hidden=availableSizes.length===0;
        const row=activeRow();
        renderCells(activeTab,row);
        const missing=dialog.querySelector(`[data-measurements-empty="${activeTab}"]`);
        if(missing)missing.hidden=Boolean(row);
        panels[activeTab]?.querySelector('.measurements-dialog__table')?.toggleAttribute('hidden',!row);
        if(activeTab==='item'){
          const v=formVariant();
          const canAdd=Boolean(row&&form&&mainSubmit&&isSizeMatch(row)&&sizeOption&&normalize(sizeOption.value)===normalize(row.dataset.size)&&v?.available&&!mainSubmit.disabled);
          basket.disabled=!canAdd;
          message.textContent=!row?'':!isSizeMatch(row)?'Select a matching product size to add to the basket.':!canAdd?'This size or selected combination is unavailable.':'';
        }
      };
      const switchTab=type=>{
        if(!panels[type])return;
        activeTab=type;
        tabs.forEach(tab=>{
          const on=tab.dataset.measurementsTab===type;
          tab.classList.toggle('is-active',on);
          tab.setAttribute('aria-selected',String(on));
          tab.tabIndex=on?0:-1;
        });
        Object.entries(panels).forEach(([key,panel])=>panel.hidden=key!==type);
        render();
      };
      const selectSize=size=>{
        activeSize=size;
        if(activeTab==='item'&&sizeOption){
          const option=$$('option',sizeOption).find(o=>normalize(o.value)===normalize(size));
          if(option&&sizeOption.value!==option.value){
            sizeOption.value=option.value;
            sizeOption.dispatchEvent(new Event('change',{bubbles:true}));
          }
        }
        render();
      };
      buttons.addEventListener('click',e=>{
        const btn=e.target.closest('[data-size]');
        if(btn)selectSize(btn.dataset.size);
      });
      tabs.forEach((tab,i)=>{
        tab.addEventListener('click',()=>switchTab(tab.dataset.measurementsTab));
        tab.addEventListener('keydown',e=>{
          if(!['ArrowRight','ArrowLeft','Home','End'].includes(e.key))return;
          e.preventDefault();
          const index=e.key==='Home'?0:e.key==='End'?tabs.length-1:
            (i+(e.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
          tabs[index].focus();switchTab(tabs[index].dataset.measurementsTab);
        });
      });
      opener.hidden=false;
      opener.addEventListener('click',()=>{
        activeSize=rows.item.find(row=>normalize(row.dataset.size)===normalize(sizeOption?.value))?.dataset.size||rows.item[0]?.dataset.size||'';
        switchTab('item');
        if(!dialog.open&&typeof dialog.showModal==='function')dialog.showModal();
      });
      variantSelects.forEach(select=>select.addEventListener('change',()=>{
        if(!dialog.open)return;
        if(activeTab==='item'&&sizeOption){
          const variantRow=rows.item.find(row=>normalize(row.dataset.size)===normalize(sizeOption.value));
          if(variantRow)activeSize=variantRow.dataset.size;
        }
        render();
      }));
      dialog.querySelector('[data-measurements-close]')?.addEventListener('click',()=>dialog.close());
      dialog.addEventListener('click',e=>{
        const bounds=dialog.getBoundingClientRect();
        if(e.target===dialog&&(e.clientX<bounds.left||e.clientX>bounds.right))dialog.close();
      });
      dialog.addEventListener('close',()=>opener.focus({preventScroll:true}));
      basket.addEventListener('click',()=>{
        render();
        if(basket.disabled||!form||!mainSubmit)return;
        dialog.close();
        if(typeof form.requestSubmit==='function')form.requestSubmit(mainSubmit);
        else mainSubmit.click();
      });
    });
  }
  initMeasurements();
  document.addEventListener('shopify:section:load',e=>initMeasurements(e.target));

  // Auto-submit collection filters when checkbox changes.
  $('#CollectionFilters')?.addEventListener('change',e=>{if(e.target.matches('input[type=checkbox]')) e.currentTarget.submit()});
})();
